
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { moduleKey } from 'app/core/constants/constants';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { environment as env } from '../../../../environments/environment';
import { ProfileSettingsService } from 'app/components/profile-settings/profile-settings.service';

@Component({
    selector       : 'user',
    templateUrl    : './user.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'user'
})
export class UserComponent implements OnInit, OnDestroy
{
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: User;

    private _unsubscribeAll: Subject<void> = new Subject<void>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _userService: UserService,
        private _zuperDialogService: ZuperDialogService,
        private utilityService: UtilityService,
        private localStorageService: LocalStorageService,
        private dataCollectorService: DataCollectorService,
        private router: Router,
        private profileSettingsService: ProfileSettingsService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void
    {
        // Return if user is not available
        if ( !this.user )
        {
            return;
        }

        // // Update the user
        // this._userService.update({
        //     ...this.user,
        //     status
        // }).subscribe();
    }

    /**
     * Sign out
     */
    signOut(): void
    {
        const logoutConfirmationMessage = `${this.utilityService.getLocaleValue('logout.confirmation.message')} ?`;
        const logoutDialog =  this._zuperDialogService.open({
                                                                title:`${this.utilityService.getLocaleValue('logout.dialog.title','Logout')}`,
                                                                message:logoutConfirmationMessage,
                                                                type:'error',
                                                                actions    : {
                                                                confirm: {
                                                                    show : true,
                                                                    label: 'Ok',
                                                                    color: 'error',
                                                                    confirmDisplayKey:'logout.dialog.title',
                                                                },
                                                                cancel : {
                                                                        show : true,
                                                                        label: 'Cancel'
                                                                    }
                                                                }
                                                            });
        logoutDialog.afterClosed().subscribe((result: any)=>{
        if(result){
                const module = this.localStorageService.getLocalStorage('current_module');
                if(module){
                    if(Object.keys(moduleKey).includes(module)){
                        const localValue = this.localStorageService.allStorage();
                        let payload = {};
                        let value = {};
                        for(const key of Object.keys(localValue)){
                            if(key.includes(module.toLowerCase()) && this.localStorageService.checkIfKeyExist(key) ){
                                value = {...value,[key]: localValue[key]};
                            }
                        }

                        payload = {
                            module: moduleKey[module.toUpperCase()],
                            key: `${module}_CACHE`,
                            value: JSON.stringify(value)
                        };
                        const metaPayload = {'meta_data':payload};
                            if(Object.keys(payload).length > 0){
                                this.dataCollectorService.postData(`${localStorage.getItem('dc_api_url')}/api/meta_data`,metaPayload).subscribe((response: any)=>{
                                    this._userService.signOut();
                                },(error: any)=>{
                                    this._userService.signOut();
                                });
                            }
                    } else {
                        this._userService.signOut();
                    }
                }else{
                    this._userService.signOut();
                }
            }
          });
    }

    hasValidProfilePicture(profilePicture: string): boolean {
        if (profilePicture) {
          return profilePicture.indexOf('profile_picture.jpg') === -1;
        }
        return false;
      }

    redirectToSettings(): void {
        localStorage.setItem('CurrentSettingsPage','/settings');
        this.router.navigateByUrl('/settings');
    }

    redirectToAppStore(): void {
        var dc_region = localStorage.getItem('dc_region') || "";
        var uri = env.appStoreURL + "?region="+ dc_region +"&access_token=" + this.localStorageService.getLocalStorage('auth_token');  
        window.open(uri)
    }

    /**
     * Show Profile Details
     */
    public showProfileDetails(): void{
      this.profileSettingsService.showProfileSettingsDialog();
    }

}
